import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from '../../common/withRouter';
import { Loader, ButtonOBSOLETED} from "../../web.common";
import {
  Filters,
  FilterInput,
  FilterTimePicker,
  FilterSelect,
} from "./Filters";
import { getQueryStringParameters } from "../../common/utils";
import { DisplayDate, DisplayGuid } from "../items";
import { LayoutContext } from "../layout/siteLayout";
import PageTop from "../layout/PageTop";
import withApi from "../higherOrderComponents/withApi";

const showEmails = [
  {
    value: "With signups",
    label: "With signups",
  },
  {
    value: "Without signups",
    label: "Without signups",
  }
];

const ConfirmationEmailInternal = (props) => {
  const [loadedData, setLoadedData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigationButtonStyle = {
    width: "6%",
    color: "grey",
    fontSize: "0.85rem",
  };

  const clickable = {
    cursor: "pointer",
  };

  useEffect(() => {
    async function loadFromApi() {
      loadData()
    }
    if (!loadedData) {
      loadFromApi();
    }
  }, []);

  const loadData = async () => {
    setIsLoading(false);
    const { history, location } = props;
    const filters = getQueryStringParameters(location.search);
    const data = await props.api.confirmationEmail.searchConfirmations({
      filters,
    });

    setLoadedData(data);

    setIsLoading(true);
  };

  const filters = getQueryStringParameters(props.location.search);
  const page = parseInt(filters.page) || 1;
  const orderBy = filters.orderBy || "createdDate";
  const orderDirection = filters.orderDirection || "desc";

    const orderHandler = (name) => {
      const { history, location } = props;
      let direction;
      if (name.toLowerCase() === orderBy.toLowerCase()) {
        direction = orderDirection === "desc" ? "asc" : "desc";
      } else {
        direction = "desc";
      }

      Filters.goToPage(history, location, page, name, direction);
    };

  const pagingHandler = async (action) => {
    const { history, location } = props;

    if (page < loadedData.pages && action === "add") {
      Filters.goToPage(history, location, page + 1, orderBy, orderDirection);
    }
    if (page > 1 && action === "sub") {
      Filters.goToPage(history, location, page - 1, orderBy, orderDirection);
    }
  };


  const header = [
    {
      name: "Id",
      label: "Id",
      canOrder: false,
      render: ({ id }) => <DisplayGuid>{id}</DisplayGuid>,
    },
    {
      name: "SignupId",
      label: "SignupId",
      canOrder: false,
      render: ({ signupId }) => <DisplayGuid>{signupId}</DisplayGuid>,
    },
    {
      name: "From",
      label: "From",
      canOrder: true,
      render: ({ from }) => <span>{from}</span>,
    },
    {
      name: "To",
      label: "To",
      canOrder: true,
      render: ({ to }) => <span>{to.replaceAll(',','\n')}</span>,
    },
    {
      name: "Subject",
      label: "Subject",
      canOrder: true,
      render: ({ subject }) => <span>{subject}</span>,
    },
    {
      name: "CreatedDate",
      label: "CreatedDate",
      canOrder: true,
      render: ({ createdDate }) => <DisplayDate>{createdDate}</DisplayDate>,
    },
  ];

  return (
    <LayoutContext.Consumer>
      {() => (
        <React.Fragment>
          {/* <Notification newMessage={errorMessage} /> */}
          <div className="content-with-right-pane-delimiter">
            <PageTop
              documentTitle="Emails"
              documentDescription="Emails"
            />
            <h2 className="main-page-header">Emails</h2>
            <Filters
              initFromUrl
              submitUrl
              validateForm={(
                {
                  id,
                  signupId,
                  createdFrom,
                  createdTo,
                  resultsPerPage,
                  hasSignup,
                  sender,
                  subject,
                  seasonalCourtPurchaseId
                },
                updatedKey
              ) => {
                if (updatedKey !== "id") {
                  return {
                    id,
                    signupId,
                    createdFrom,
                    createdTo,
                    resultsPerPage,
                    sender,
                    subject,
                    hasSignup,
                    seasonalCourtPurchaseId
                  };
                }
                return { id };
              }}
              render={(formData, update) => (
                <div className="filters-block">
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="id">
                      Email Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="id"
                      placeholder="Find by id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="seasonalCourtPurchaseId">
                    Seasonal Court Purchase Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="seasonalCourtPurchaseId"
                      placeholder="Find by seasonal Court Purchase Id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="signupId">
                      Signup Id
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="signupId"
                      placeholder="Find by signup id"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="createdFrom">
                      Created From
                    </label>
                    <FilterTimePicker
                      className="filter-date-picker"
                      data={formData}
                      update={update}
                      name="createdFrom"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="createdTo">
                      Created To
                    </label>
                    <FilterTimePicker
                      data={formData}
                      update={update}
                      name="createdTo"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="resultsPerPage">
                      Results Per Page
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="resultsPerPage"
                      placeholder="insert number of result to show per page"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="hasSignup">
                      Signups
                    </label>
                    <FilterSelect
                      className="filter-select"
                      data={formData}
                      update={update}
                      name="hasSignup"
                      options={showEmails}
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="sender">
                      Sender
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="sender"
                      placeholder="Find by sender"
                    />
                  </div>
                  <div className="filters-label-block">
                    <label className="filters-label" htmlFor="subject">
                      Subject
                    </label>
                    <FilterInput
                      data={formData}
                      update={update}
                      name="subject"
                      placeholder="Find by subject"
                    />
                  </div>
                  <br />
                  <br />
                  <div className="filters-submit-wrapper">
                    <ButtonOBSOLETED
                      type="submit"
                      buttonContent="Search"
                      disabled={!isLoading}
                    />
                  </div>
                  <hr />
                </div>
              )}
            />
            {loadedData == null ? (
              <Loader hasLoaded={false} />
            ) : (
              <>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="< Prev"
                    onClick={() => pagingHandler("sub")}
                  />
                  <span style={{ color: "grey", fontSize: "0.85rem" }}>
                    Showing page {page} out of {loadedData.pages}
                  </span>
                  <input
                    style={navigationButtonStyle}
                    type="button"
                    value="Next >"
                    onClick={() => pagingHandler("add")}
                  />
                </div>
                <br />
                <article className="data-table-wrap">
                  <table className="data-lists component-data-table cell-content-align-top">
                    <thead>
                      <tr>
                        {header.map((property) => (
                          <td
                            style={property.canOrder ? clickable : null}
                            onClick={() =>
                              typeof property === "object" && property.canOrder
                                ? orderHandler(property.label)
                                : property
                            }
                          >
                            {typeof property === "object"
                              ? property.label
                              : property}{" "}
                            {orderBy.toLowerCase() ===
                            property.label.toLowerCase()
                              ? orderDirection === "desc"
                                ? "↓"
                                : "↑"
                              : ""}
                          </td>
                        ))}
                      </tr>
                    </thead>
                    {loadedData.confirmations.map((row) => (
                      <tbody>
                        <tr
                          className="hover-listview "
                          onClick={() =>
                            props.history.push(
                              `/email/${row["id"]}`
                            )
                          }
                        >
                          {header.map((property) => (
                            <td>
                              <strong className="table-cell-label">
                                {typeof property === "object"
                                  ? property.label
                                  : property}
                              </strong>
                              {typeof property === "object" ? (
                                property.render(row)
                              ) : (
                                <span>{row[property]}</span>
                              )}
                            </td>
                          ))}
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </article>
              </>
            )}
          </div>
        </React.Fragment>
      )}
    </LayoutContext.Consumer>
  );























};

const ConfirmationEmails = withRouter(
  withApi(connect(({ user }) => ({ isLoggedIn: !!user }), {})(ConfirmationEmailInternal))
);

ConfirmationEmails.requiresLogin = true;
ConfirmationEmails.propTypes = { isLoggedIn: PropTypes.bool };

export default ConfirmationEmails;
